module.exports = __webpack_public_path__ + "img/Home2m.05dbd086.png";